const FREEPASS_TICKET_IMG_URL =
  "https://cdn.navalabs.io/icons/freepass_j7fqhb.png";
const GACHA_COIN_IMG_URL =
  "https://cdn.navalabs.io/icons/gacha-icon_Gf5APY.png";
const LUCKY_DRAW_TICKET_IMG_URL =
  "https://cdn.navalabs.io/icons/ticket_33hdbL.png";

export const DOUBLE_TROPHY_IMG_URL =
  "https://cdn.navalabs.io/icons/double-trophy_r6n5qf.png";

export const getRewardIcon = (rewardType: string): string => {
  switch (rewardType) {
    case "free_pass":
      return FREEPASS_TICKET_IMG_URL;
    case "gacha_coin":
      return GACHA_COIN_IMG_URL;
    case "lucky_draw":
      return LUCKY_DRAW_TICKET_IMG_URL;
    case "double_trophies":
      return DOUBLE_TROPHY_IMG_URL;
    case "usdc":
      return "https://cdn.navalabs.io/icons/usdc-icon_24GLmN.png";
    case "trophies":
    default:
      return "https://cdn.navalabs.io/icons/trophy-icon_zozppj.png";
  }
};

export const ALLOWED_ROUTES = [
  "/home",
  "/world",
  "/koth",
  "/rush",
  "/winner-takes-all",
  "/grand-rush",
  "/practice",
  "/championship",
  "/hosted-tournament",
  "/lucky-draw",
];

export const BUTTON_CLIP_PATH = `polygon(
  0px calc(100% - 6px),
  3px calc(100% - 6px),
  3px calc(100% - 3px),
  6px calc(100% - 3px),
  6px 100%,
  100% 100%,
  100% 0px,
  6px 0px,
  6px 3px,
  3px 3px,
  3px 6px,
  0px 6px
)`;

export const BADGE_CLIP_PATH = `polygon(
  0px calc(100% - 4px),
  2px calc(100% - 4px),
  2px calc(100% - 2px),
  4px calc(100% - 2px),
  4px 100%,
  calc(100% - 4px) 100%,
  calc(100% - 4px) calc(100% - 2px),
  calc(100% - 2px) calc(100% - 2px),
  calc(100% - 2px) calc(100% - 4px),
  100% calc(100% - 4px),
  100% 4px,
  calc(100% - 2px) 4px,
  calc(100% - 2px) 2px,
  calc(100% - 4px) 2px,
  calc(100% - 4px) 0px,
  4px 0px,
  4px 2px,
  2px 2px,
  2px 4px,
  0px 4px
)`;
